<template>

  
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <br>

    <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Leave Master</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
               
                <v-col cols="12" sm="12" md="3">
                    <b>Academic Year</b>
                    <v-autocomplete v-model="academicYear" :items="academic_year_list" item-text="academicYear"
                        item-value="id" label="Academic Year" single-line rounded outlined dense ></v-autocomplete>
                </v-col>

                <!-- <v-col cols="12" sm="12" md="3">
                    <b>Leave Type</b>
                    <v-autocomplete v-model="leaveType" :items="leave_type_list"
                        label="Leave Type" item-text="leaveType" item-value="id" single-line rounded outlined
                        dense multiple></v-autocomplete>
                </v-col> -->

                <v-col cols="12" sm="12" md="3">
    <b>Leave Type</b>

    <v-autocomplete
        v-model="leaveType"
        :items="leave_type_list"
        label="Leave Type"
        item-text="leaveType"
        item-value="id"
        single-line
        rounded
        outlined
        dense
        multiple
        clearable
        @change="leaveTypeChanged"
    >

        <!-- SELECT ALL -->
        <template v-slot:prepend-item>
            <v-list-item
                ripple
                @click="selectAllLeaveTypes"
            >
                <v-list-item-action>
                    <v-checkbox
                        :input-value="allLeaveTypesSelected"
                        color="primary"
                    ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                    <v-list-item-title>
                        <strong>Select All</strong>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
        </template>

        <!-- CHECKBOX FOR EACH LEAVE TYPE -->
        <template v-slot:item="{ item }">
            <v-list-item-action>
                <v-checkbox
                    :input-value="leaveType.includes(item.id)"
                    color="primary"
                    @click.stop
                ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
                <v-list-item-title>
                    {{ item.leaveType }}
                </v-list-item-title>
            </v-list-item-content>
        </template>

    </v-autocomplete>
</v-col>

                <!-- <v-col cols="12" sm="12" md="3">
                    <b>Employee Type</b>
                    <v-autocomplete v-model="employeeType" :items="employee_type_list"
                        label="Certificate Type" item-text="employeeType" item-value="id" single-line rounded outlined
                        dense multiple></v-autocomplete>
                </v-col> -->

                <v-col cols="12" sm="12" md="3">
    <b>Employee Type</b>

    <v-autocomplete
        v-model="employeeType"
        :items="employee_type_list"
        label="Employee Type"
        item-text="employeeType"
        item-value="id"
        single-line
        rounded
        outlined
        dense
        multiple
        clearable
        @change="employeeTypeChanged"
    >

        <!-- SELECT ALL -->
        <template v-slot:prepend-item>
            <v-list-item
                ripple
                @click="selectAllEmployeeTypes"
            >
                <v-list-item-action>
                    <v-checkbox
                        :input-value="allEmployeeTypesSelected"
                        color="primary"
                    ></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                    <v-list-item-title>
                        <strong>Select All</strong>
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>
        </template>

        <!-- CHECKBOX FOR EACH EMPLOYEE TYPE -->
        <template v-slot:item="{ item }">
            <v-list-item-action>
                <v-checkbox
                    :input-value="employeeType.includes(item.id)"
                    color="primary"
                    @click.stop
                ></v-checkbox>
            </v-list-item-action>

            <v-list-item-content>
                <v-list-item-title>
                    {{ item.employeeType }}
                </v-list-item-title>
            </v-list-item-content>
        </template>

    </v-autocomplete>
</v-col>

                <v-col cols="12" sm="12" md="3">
                    <b>Employee Category</b>
                    <v-autocomplete v-model="serviceType" :items="service_type_list"
                        label="Employee Category" item-text="name" item-value="id" single-line rounded outlined
                        dense multiple></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="3"></v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-col cols="12" sm="12" md="2">
                    <v-btn class="button" @click="fetchLeaveReport()">Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- {{leave_master_list}} -->
    <v-data-table :headers="headers" :items="leave_master_list" class="elevation-1 mytable" :search="search">
      <template v-slot:top>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>Leave Master</v-toolbar-title>

          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
          </v-text-field>

          <span style="width: 20px"></span>

          <v-dialog v-model="dialog" max-width="900px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on">Add Leave Master</v-btn>
            </template>
            <v-card class="card-container">
              <v-form v-model="valid">
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <!-- <v-col cols="12" sm="12" md="1"></v-col> -->

                      <v-col cols="12" sm="3" md="3">
                        <v-text-field v-if="editedIndex > -1" rounded outlined dense v-model="editedItem.academicYear"
                          item-text="academicYear" item-value="id" label="Academic Year" readonly single-line return-object
                          disabled></v-text-field>

                        <v-autocomplete v-else rounded outlined dense v-model="academicYear"
                          :items="academic_year_list" :rules="[(v) => !!v || 'required']" item-text="academicYear" item-value="id"
                          label="Academic Year" :filled="editedIndex == -1 ? false : true" single-line></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-text-field v-if="editedIndex > -1" rounded outlined dense v-model="editedItem.leaveType"
                          item-text="leaveType" item-value="id" label="Leave Type" single-line readonly
                          disabled></v-text-field>

                        <v-autocomplete v-else rounded outlined dense v-model="leaveType"
                          :items="leave_type_list" :rules="[(v) => !!v || 'required']" item-text="leaveType" item-value="id"
                          label="Leave Type" :filled="editedIndex == -1 ? false : true" single-line></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="3" md="3">
                        <v-text-field v-if="editedIndex > -1" rounded outlined dense v-model="editedItem.employeeType"
                          item-text="employeeType" item-value="id" label="Employee Type" readonly single-line
                          disabled></v-text-field>

                        <v-autocomplete v-else rounded outlined dense v-model="employeeType"
                          :items="employee_type_list" :rules="[(v) => !!v || 'required']" item-text="employeeType"
                          item-value="id" label="Employee Type" :filled="editedIndex == -1 ? false : true"
                          single-line></v-autocomplete>
                      </v-col>

                       <v-col cols="12" sm="3" md="3">
                        <v-text-field v-if="editedIndex > -1" rounded outlined dense v-model="editedItem.serviceType"
                          item-text="name" item-value="id" label="Employee Category" readonly single-line
                          disabled></v-text-field>

                        <v-autocomplete v-else rounded outlined dense v-model="serviceType"
                          :items="service_type_list" item-text="name"
                          item-value="id" label="Employee Category" :filled="editedIndex == -1 ? false : true"
                          single-line clearable></v-autocomplete>
                      </v-col>
                    </v-row>
                    <!-- <br /> -->
                    <v-row dense justify="center">
                      <v-col cols="12" sm="12" md="1"></v-col>
                      <v-col cols="12" sm="6" md="3">
                        <b>From Date</b>
                        <input id="datePickerId" type="date" v-model="editedItem.from" />

                        <!-- <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="editedItem.from"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.from"
                                label="From Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="[v => !!v || 'required']"
                                rounded
                                outlined
                                dense
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="editedItem.from"
                            no-title
                            scrollable>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu = false"
                            >Cancel</v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu.save(editedItem.from)"
                            >OK</v-btn>
                            </v-date-picker>
                        </v-menu>              -->
                      </v-col>
                      <!-- {{editedItem.from}} -->
                      <v-col cols="12" sm="6" md="3">
                        <b>To Date</b>
                        <input id="datePickerId" type="date" v-model="editedItem.to" />
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <br />
                        <v-text-field v-model="editedItem.numberOfDays" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 1,2,3'
                              : 'For example :: 1,2,3'
                          " label="Number Of Day" :rules="[(v) => !!v || 'required']" type="number" rounded outlined
                          dense>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense justify="center">
                      <v-col cols="12" sm="4" md="4">
                        <br />
                        <v-text-field v-model="editedItem.maxleavesinmonth" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 1,2,3'
                              : 'For example :: 1,2,3'
                          " label="Max No Of Leaves In Month" :rules="[(v) => !!v || 'required']" type="number" rounded
                          outlined dense>
                        </v-text-field>
                      </v-col>

                       <v-col cols="12" sm="4" md="4">
                        <br />
                        <v-text-field v-model="editedItem.payrollDeductionOrder" persistent-hint label="Payroll Deduction Order" type="number" rounded
                          outlined dense :rules="[v => (v === 0 || !!v) || 'required']">
                        </v-text-field>
                      </v-col>

                       <v-col cols="12" sm="4" md="4">
                        <br />
                        <v-text-field v-model="editedItem.payrollDeductionDays" persistent-hint label="Payroll Deduction Days" type="number" rounded
                          outlined dense :rules="[v => (v === 0 || !!v) || 'required']">
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <!-- <v-col cols="10" sm="3">
                        <v-menu
                            ref="menu1"
                            v-model="menu1"
                            :close-on-content-click="false"
                            :return-value.sync="editedItem.to"
                            transition="scale-transition"
                            offset-y
                            min-width="auto" >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.to"
                                label="To Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :rules="[v => !!v || 'required']"
                                rounded
                                outlined
                                dense
                            ></v-text-field>
                            </template>
                            <v-date-picker
                            :min="editedItem.from"
                            v-model="editedItem.to"
                            no-title
                            scrollable
                             >
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                color="primary"
                                @click="menu1 = false"
                            >Cancel </v-btn>
                            <v-btn
                                text
                                color="primary"
                                @click="$refs.menu1.save(editedItem.to)"
                            > OK </v-btn>
                            </v-date-picker>
                        </v-menu>             
                    </v-col>       -->
                    <!-- {{editedItem.toDate}} -->

                    <v-row dense>
                      <v-col cols="12" sm="12" md="1"></v-col>

                      <v-col cols="10" sm="3" md="3">
                        <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <!-- <v-row dense>
          <v-col cols="12" sm="3" md="3" v-for="header in headers" :key="header.text">
            <v-autocomplete v-if="filters.hasOwnProperty(header.value)" class="mr-2 pb-5 pt-2" flat hide-details small
              rounded dense outlined color="#0F2027" :label="header.text" multiple clearable
              :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
          </v-col>
        </v-row> -->
      </template>

      <template v-slot:[`item.isactive`]="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Leave Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    errorMsg: {
      castId: false,
    },
    menu: "",
    menu1: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    filterArr: [],
    academicYear:"",
    leaveType:"",
    employeeType:"",
    serviceType:"",
    headers: [
      {
        text: "Academic Year",
        align: "left",
        sortable: true,
        value: "academicyear",
      },
      {
        text: "Leave Type",
        align: "left",
        sortable: true,
        value: "leavetype",
      },
      {
        text: "Employee Type",
        align: "left",
        sortable: true,
        value: "employeetype",
      },
      {
        text: "Employee Category",
        align: "left",
        sortable: true,
        value: "servicetype",
      },
      {
        text: "From Date",
        align: "left",
        sortable: true,
        value: "fromdate",
      },
      {
        text: "To Date",
        align: "left",
        sortable: true,
        value: "todate",
      },
      {
        text: "Number Of Days",
        align: "left",
        sortable: true,
        value: "numberofdays",
      },
      {
        text: "Max Number Of Leaved In Month",
        align: "left",
        sortable: true,
        value: "maxleavesinmonth",
      },
      {
        text: "Payroll Deduction Order",
        align: "left",
        sortable: true,
        value: "payrollDeductionOrder",
      },
      {
        text: "Payroll Deduction Days",
        align: "left",
        sortable: true,
        value: "payrollDeductionDays",
      },
      {
        text: "Is Active?",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      {
        text: "Actions",
        value: "action",
        sortable: false,
      },
    ],
    leave_master_list: [],
    leave_type_list: [],
    academic_year_list: [],
    employee_type_list: [],
    service_type_list : [],
    editedIndex: -1,
    editedItem: {
      leaveMasterId: "",
      academicYear: "",
      leaveType: [],
      isActive: true,
      employeeType: [],
      fromDate: "",
      toDate: "",
      from: "",
      to: "",
      numberOfDays: "",
      maxleavesinmonth: "",
      academicYearId: "",
      leaveTypeId: "",
      employeeTypeId: "",
      serviceType: [],
      serviceTypeId: "",
      payrollDeductionOrder:"",
      payrollDeductionDays:"",

    },
    defaultItem: {
      leaveMasterId: "",
      academicYear: "",
      leaveType: "",
      isActive: true,
      employeeType: "",
      fromDate: "",
      toDate: "",
      numberOfDays: "",
      serviceType: "",
      payrollDeductionOrder:"",
      payrollDeductionDays:"",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Leave Master" : "Edit Leave Master";
    },

      allLeaveTypesSelected() {
        return (
            this.leave_type_list.length > 0 &&
            this.leaveType.length === this.leave_type_list.length
        );
    },

    allEmployeeTypesSelected() {
        return (
            this.employee_type_list.length > 0 &&
            this.employeeType.length === this.employee_type_list.length
        );
    },

  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    columnValueList(val) {
      return this.leave_master_list.map((d) => d[val]);
    },
    calculateDays() {
      this.loader = true;
      const formData = {
        date_1: this.editedItem.fromDate,
        date_2: this.editedItem.toDate,
      };
      axios
        .post("/LeaveManagement/calculateDays", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.loader = false;
            this.editedItem.numberOfDays = res.data.noOfDaysBetween;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.loader = false;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
        });
    },

    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    fetchLeaveReport() {
      this.overlay = true;


        const data = {
                academicYear: this.academicYear,
                leaveType: this.leaveType,
                employeeType:this.employeeType,
                serviceType:this.serviceType
            }
      
        axios
          .post("/LeaveManagement/getLeaveMasterList",data)
          .then((res) => {
            if (res.data.msg == "200") {
              if ((this.load = true)) {
                this.overlay = false;
                this.leave_master_list =
                  res.data.leave_master_list;
              }
            } else if (res.data.msg == "NDF") {
              this.showSnackbar("#b71c1c", "No Data Found");
              // this.onLoad();
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            this.overlay = false;
          });
      
    },

    onLoad() {
      // this.overlay = true;
      axios
        .post("/LeaveManagement/getLeaveMaster")
        .then((res) => {
          if (res.data.msg == "200") {
            // this.showSnackbar("#b71c1c", "Something went wrong...");
              this.overlay = false;
              this.leave_type_list = res.data.leave_type_list;
              this.academic_year_list = res.data.academic_year_list;
              this.employee_type_list = res.data.employee_type_list;
              this.editedItem.academicYear = res.data.cay;
              this.service_type_list = res.data.service_type_list;
          } 
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log("Errro------>" + error);
        })
        .finally(() => {
         this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.leave_master_list.indexOf(item);
      //window.alert(JSON.stringify(this.editedIndex))
      this.dialog = true;
      this.editedItem.leaveMasterId = item.id;
      this.editedItem.academicYear = item.academicyear;
      this.editedItem.academicYearId = item.academicyearid;
      this.editedItem.leaveType = item.leavetype;
      this.editedItem.leaveTypeId = item.leavetypeid;
      this.editedItem.employeeType = item.employeetype;
      this.editedItem.employeeTypeId = item.employeetypeid;
      this.editedItem.serviceType = item.servicetype;
      this.editedItem.serviceTypeId = item.servicetypeid;
      this.editedItem.fromDate = item.fromdate;
      this.editedItem.toDate = item.todate;
      this.editedItem.from = item.from;
      this.editedItem.to = item.to;
      this.editedItem.numberOfDays = item.numberofdays;
      this.editedItem.maxleavesinmonth = item.maxleavesinmonth;
      this.editedItem.payrollDeductionOrder = item.payrollDeductionOrder;
      this.editedItem.payrollDeductionDays = item.payrollDeductionDays;
      this.editedItem.isActive = item.isactive;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },



    save() {
      //window.alert(JSON.stringify(this.editedItem.leaveMasterId))
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          const formData = {
            leaveMasterId:this.editedItem.leaveMasterId,
            leaveTypeId: this.editedItem.leaveTypeId,
            academicyearId: this.editedItem.academicYearId,
            from: this.editedItem.from,
            to: this.editedItem.to,
            numberOfDays: this.editedItem.numberOfDays,
            maxleavesinmonth: this.editedItem.maxleavesinmonth,
            isActive: this.editedItem.isActive,
            employeeTypeId: this.editedItem.employeeTypeId,
            serviceTypeId : this.editedItem.serviceTypeId,
            payrollDeductionOrder: this.editedItem.payrollDeductionOrder,
            payrollDeductionDays : this.editedItem.payrollDeductionDays
            
          };

          axios
            .post("/LeaveManagement/editLeaveMaster", formData)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar(
                  "#4caf50",
                  "Leave Master Updated Successfully..."
                ); // show snackbar on success
                this.fetchLeaveMasters();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Leave Master Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        const formData = {
          academicYear: this.academicYear,
          leaveType: this.leaveType,
          employeeType:this.employeeType,
          serviceType:this.serviceType,
          from: this.editedItem.from,
          to: this.editedItem.to,
          numberOfDays: this.editedItem.numberOfDays,
          maxleavesinmonth: this.editedItem.maxleavesinmonth,
          isActive: this.editedItem.isActive,
          payrollDeductionOrder: this.editedItem.payrollDeductionOrder,
          payrollDeductionDays : this.editedItem.payrollDeductionDays
        };
        //window.alert(JSON.stringify(this.editedItem))
        axios
          .post("/LeaveManagement/saveLeaveMaster", formData)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                "Leave Master Added Successfully..."
              ); // show snackbar on success
              this.fetchLeaveMasters();
              // this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Leave Master Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    selectAllLeaveTypes() {

    if (this.allLeaveTypesSelected) {

        // Unselect all
        this.leaveType = [];

    } else {

        // Select all IDs
        this.leaveType = this.leave_type_list.map(item => item.id);

    }
},

selectAllEmployeeTypes() {

    if (this.allEmployeeTypesSelected) {

        // Unselect all
        this.employeeType = [];

    } else {

        // Select all IDs
        this.employeeType = this.employee_type_list.map(item => item.id);

    }
},

leaveTypeChanged(value) {

    console.log("Selected Leave Types:", value);

},

  allLeaveTypesSelected() {
        return (
            this.leave_type_list.length > 0 &&
            this.leaveType.length === this.leave_type_list.length
        );
    },

    allEmployeeTypesSelected() {
        return (
            this.employee_type_list.length > 0 &&
            this.employeeType.length === this.employee_type_list.length
        );
    },


    isValidated() {
      if (this.editedItem.leaveMasterId) {
        return true;
      } else {
        if (!this.editedItem.leaveMasterId) {
          this.errorMsg.leaveMasterId = true;
        }
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>

<style scoped>
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.4rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}

.card-container {
  overflow-x: hidden;
  overflow: hidden;
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.toolbar {
  /* margin-top: 30px; */
  margin-bottom: 2%;
}
</style>
